module.exports = __webpack_public_path__ + "media/stencils/prototype_smt_stencils-fbed496d.png";